import { render, staticRenderFns } from "./HomeCustomIcon.vue?vue&type=template&id=18dc3cb2&scoped=true"
import script from "./HomeCustomIcon.vue?vue&type=script&lang=ts"
export * from "./HomeCustomIcon.vue?vue&type=script&lang=ts"
import style0 from "./HomeCustomIcon.vue?vue&type=style&index=0&id=18dc3cb2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18dc3cb2",
  null
  
)

export default component.exports